<!-- Navbar -->
<nav class="main-header auction-header navbar navbar-expand navbar-light border-0" [class.is-scrolled]="isScrolled">

  <app-ng-dynamic-breadcrumb [symbol]="'>'" [bgColor]="'transparent'" [fontSize]="'15px'" [fontColor]="'#161c24'"
    [lastLinkColor]="'#323639'">
  </app-ng-dynamic-breadcrumb>

  <ul class="navbar-nav auction-header-list ml-auto align-items-center">

    <!-- Notifications -->
    <li class="nav-item auction-header-item dropdown" dropdown>
      <a href="javascript:void(0)" class="nav-link auction-header-link icon-btn" dropdownToggle>
        <i class="las la-bell"></i>
        <span class="notification-marker"></span>
      </a>

      <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right notif-dropdown" *dropdownMenu>
        <div class="dropdown-header">
          <span>Notifications</span>
        </div>
        <div class="dropdown-empty">
          <i class="las la-bell-slash"></i>
          <p>No new notifications</p>
        </div>
      </div>
    </li>

    <!-- Divider -->
    <li class="nav-divider"></li>

    <!-- User -->
    <li class="nav-item auction-header-item user-dropdown dropdown" dropdown>
      <a href="javascript:void(0)" class="nav-link auction-header-link user-toggle" dropdownToggle>
        <span class="user-pf">
          <img [src]="userDetails?.['profileImageUrl']?.['presigned_url'] || env+'assets/img/default-profile.png'"
            alt="" class="user-pf-img" />
        </span>
        <span class="user-name">{{ loggedUsername || 'Admin' }}</span>
        <i class="las la-angle-down dropdown-arrow"></i>
      </a>

      <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right user-dropdown-menu" *dropdownMenu>
        <div class="dropdown-user-info">
          <img [src]="userDetails?.['profileImageUrl']?.['presigned_url'] || env+'assets/img/default-profile.png'"
            alt="" class="user-pf-img-lg" />
          <div>
            <p class="user-full-name">{{ loggedUsername || 'Admin' }}</p>
            <p class="user-role">Administrator</p>
          </div>
        </div>

        <div class="dropdown-divider"></div>

        <ul class="list-unstyled dropdown-actions">
          <li (click)="Logout()">
            <i class="las la-sign-out-alt"></i>
            <span>Logout</span>
          </li>
        </ul>
      </div>
    </li>

  </ul>
</nav>
<!-- /.navbar -->